import PageHeader from "./PageHeader";
import PageTitle from "./PageTitle";
import LinearChart from "./LinearChart";
import {ITPColorsLegend} from "../constants";
import ReportService from "../../services/ReportService";

const ProgressResultComparison = ({assessment = null}) => {
    let show_note = 0;
    const renderScoringChart = (category, initialScore, currentScore, index) => {
        if(currentScore <= initialScore) {
            show_note++;
        }
        const initialScoreColoring = Object.values(ITPColorsLegend).find(({min, max}) => initialScore >= min && initialScore <= max);
        const currentScoreColoring = Object.values(ITPColorsLegend).find(({min, max}) => currentScore >= min && currentScore <= max);
        let difference = currentScore > initialScore ? 'slight_improvement' : (currentScore < initialScore ? 'slight_decline' : 'match');

        if(initialScoreColoring.label !== currentScoreColoring.label) {
            difference = difference.replace('slight_', '');
        }

        const description = ReportService.ITPProgressResultComparisonDescriptor(category, currentScoreColoring.label?.toUpperCase(), difference);
        return (
            <>
                <p className={'font-bold text-[12pt] pt-5'}>{category}</p>
                <p className={'text-[10pt] leading-none mt-2'} dangerouslySetInnerHTML={{__html: description}}>
                </p>
                <p className={'font-bold text-[10pt] ml-8 mt-4'}>
                    Current
                </p>
                <div className={'ml-8 mr-8 -mb-2'}>
                    <LinearChart score={ReportService.formatITPScore(currentScore)} show_score_only={true} score_position={'10%'} chart_width={'w-[85%]'} />
                </div>
                <p className={'font-bold text-[10pt] ml-8'}>
                    Initial
                </p>
                <div className={'ml-8 mr-8 -mb-2'}>
                    <LinearChart score={ReportService.formatITPScore(initialScore)}show_score_only={true} score_position={'10%'}  chart_width={'w-[85%]'} />
                </div>
                { index < 2 && (<hr className={'!mt-4 !mb-4'}/>) }
            </>
        );
    }

    const renderScoring = () => {
        return assessment?.initialAssessmentSorted?.map((item, index) => {
            const category = item?.[0];
            const currentScoring = assessment?.progressAssessmentSorted?.find(item => item?.[0] === category);
            const currentScoringValue = currentScoring?.[1];
            const initialScoringValue = item?.[1];
            return renderScoringChart(category, initialScoringValue, currentScoringValue, index);
        })
    }

    return (
        <div className='ChartResultsComparison'>
            <PageHeader title={'Results'} />
            <div className='comparison-result'>
                <PageTitle title={'Overall Results Comparison'}/>
                {renderScoring()}
                { show_note > 0 &&
                    (
                        <p className={'text-[10pt] leading-tight mt-8'}>
                            Note: If you have a decline in any area from your initial assessment to your most recent, that’s okay. This change might
                            reflect a deeper understanding or improved awareness of a given virtue, rather than a step in the wrong direction.
                        </p>
                    )
                }
            </div>
        </div>
    );
}

export default ProgressResultComparison;
